import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, useTheme, IconButton, Container } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { ColorModeContext } from '../context/ThemeContext';
import { Link } from 'react-router-dom'; // Import Link

const navLinks = [
  { title: 'Home', path: '/' },
  { title: 'Community', path: '/community' }, // Changed Topics to Community
  { title: 'Resources', path: '/resources' },
  { title: 'FAQ', path: '/faq' }, // Added FAQ link
];

export const Header = () => {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);

  return (
    <AppBar position="sticky" color="inherit" elevation={1}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* 1. Logo (left) - Linked to Home */}
          <MenuBookIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, color: theme.palette.primary.main }} />
          <Typography
            variant="h6"
            noWrap
            component={Link} // Use Link component
            to="/"
            sx={{
              mr: 4,
              display: { xs: 'none', md: 'flex' },
              fontWeight: 700,
              letterSpacing: '.1rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            POME
          </Typography>

          {/* 2. Navigation Links (center) */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
            {navLinks.map((link) => (
              <Button
                key={link.title}
                component={Link} // Use Link component
                to={link.path}
                sx={{ 
                  mx: 1, 
                  color: theme.palette.text.primary, 
                  display: 'block', 
                  '&:hover': { 
                    color: theme.palette.primary.main, 
                    backgroundColor: 'transparent' 
                  }
                }}
              >
                {link.title}
              </Button>
            ))}
          </Box>
          
          {/* Mobile Menu Icon (Hidden on Desktop) */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
             <Typography variant="h6" component={Link} to="/" sx={{ color: theme.palette.primary.main, textDecoration: 'none' }}>POME</Typography>
          </Box>
          
          {/* 3. Login / Signup (right) + Theme Toggle */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={colorMode.toggleColorMode} color="inherit" sx={{ mr: 1 }}>
              {theme.palette.mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
            <Button 
              variant="outlined" 
              component={Link} // Use Link component
              to="/login"
              sx={{ mr: 1, borderColor: theme.palette.secondary.main, color: theme.palette.secondary.main }}
            >
              Login
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              component={Link} // Use Link component
              to="/signup"
            >
              Sign Up
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};